import downloadFile from '@/utils/downloadFile';
import downloadS3File from '@/utils/downloadS3File';

import { getType } from 'typesafe-actions';

import { defaultValuesFXHeatmap } from '../constants';

import * as fxAnalysisActions from './actions';
import { FxAnalysisActionType, FxAnalysisState } from './types';

const initialFxAnalysisState: FxAnalysisState = {
  heatmapInputs: defaultValuesFXHeatmap,
  downloadFxReport: { loading: false, error: null },
};

const fxAnalysisReducer = (
  state: FxAnalysisState = initialFxAnalysisState,
  action: FxAnalysisActionType,
): FxAnalysisState => {
  switch (action.type) {
    case getType(fxAnalysisActions.updateHeatmapInputs.request):
    case getType(fxAnalysisActions.updateHeatmapInputs.success):
      return {
        ...state,
        heatmapInputs: {
          ...state.heatmapInputs,
          ...action.payload,
        },
      };

    case getType(fxAnalysisActions.updateHeatmapInputs.failure):
      return state;

    case getType(fxAnalysisActions.downloadFxReportActions.request):
      return {
        ...state,
        downloadFxReport: { loading: true, error: null },
      };

    case getType(fxAnalysisActions.downloadFxReportActions.success): {
      const payload = action.payload;
      if (payload.success && payload.data && !Array.isArray(payload.data)) {
        const { file_s3_url, file_name, file_path } = payload.data as any;
        if (file_s3_url && file_name) downloadS3File(file_s3_url, file_name);
        else downloadFile(file_path, file_name); // To change after backend fix
      }
      return {
        ...state,
        downloadFxReport: { loading: false, error: null },
      };
    }

    case getType(fxAnalysisActions.downloadFxReportActions.failure):
      return {
        ...state,
        downloadFxReport: { loading: false, error: action.payload },
      };

    default:
      return state;
  }
};

export default fxAnalysisReducer;
